module.exports = __webpack_public_path__ + "static/media/sword-vertical-symmetrical-words8.d8dc871c.png";